// PowerSync database singleton + lifecycle (local-first migration, Phase 3).
//
// Gated behind VITE_LOCAL_FIRST so the cloud web app is untouched until the
// flag is flipped. The DB (and its wasm/worker) is only instantiated when the
// flag is on AND connect is called, so the disabled path pays nothing at runtime.
import { PowerSyncDatabase } from '@powersync/web';
import { AppSchema } from './schema';
import { MissionControlConnector } from './connector';

export const LOCAL_FIRST = import.meta.env.VITE_LOCAL_FIRST === 'true';

let _db = null;
let _connected = false;

/** Lazily create (but do not connect) the local database. */
export function getPowerSync() {
  if (!_db) {
    _db = new PowerSyncDatabase({
      schema: AppSchema,
      database: { dbFilename: 'missioncontrol.db' },
    });
  }
  return _db;
}

/** Connect to the sync service. Idempotent. No-op if the flag is off. */
export async function connectPowerSync() {
  if (!LOCAL_FIRST || _connected) return _db;
  const db = getPowerSync();
  await db.init();
  await db.connect(new MissionControlConnector());
  _connected = true;
  return db;
}

export async function disconnectPowerSync() {
  if (_db && _connected) {
    await _db.disconnect();
    _connected = false;
  }
}

export function isLocalFirstActive() {
  return LOCAL_FIRST && _connected;
}
